import { useEffect, useState } from "react";
import {
	Drawer,
	DrawerBody,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
} from "@chakra-ui/react";
import { TabHeader } from "components/TabHeader";
import { CloseButton } from "components/RFQ/CloseButton";
import { Button } from "newui/components/Button";
import apiV2 from "api-v2";
import { useDispatch } from "react-redux";
import { addSupplierList } from "actions/searchActions";
import { navigate } from "@reach/router";
import Select, { components } from "react-select";
import LabelForm from "components/RFQ/LabelForm/LabelForm";
import { Badge } from "components/RFQ/Badge";
import { Icon } from "assets/Icon";
import { showToast } from "utils/helpers";
import { useCurrentCompanyId, useCurrentUser } from "hooks/auth";

const AddSupplierDrawer = ({
	onClose,
	isOpen,
	listCompanies,
	activeSupplierList,
	...props
}) => {
	const [availableList, setAvailableList] = useState([]);
	const companyId = useCurrentCompanyId();
	const [listSupplierId, setListSupplierId] = useState(activeSupplierList);
	const dispatch = useDispatch();
	const { isCompanyAdmin } = useCurrentUser();

	const getSupplierList = async () => {
		let res = await apiV2.get(`supplier/list-of-supplier-list`);
		if (res.status === 200) {
			let resultData = [];
			let tempData = res?.data?.data;
			for (let a = 0; a < tempData.length; a++) {
				resultData.push({
					label: tempData[a]?.name,
					value: tempData[a]?.id,
					total: tempData[a]?.total,
					isPanel: tempData[a]?.is_company_approved_list,
				});
			}
			setAvailableList(
				isCompanyAdmin ? resultData : resultData.filter((item) => !item.isPanel)
			);
		}
	};

	const CustomOption = (props) => {
		// Format the option text with HTML
		const isChecked = listSupplierId === props.data.value;
		return (
			<components.Option {...props}>
				<div className="flex justify-between">
					<div>
						<b>{props.data.label}</b> <span>{props.data.total}</span>
					</div>
					<div className="flex items-center gap-2">
						<Badge
							type="dot"
							className="!border-0"
						>
							{props.data?.isPanel ? "Panel" : "Suppliers"}
						</Badge>
						<div>
							{isChecked && (
								<Icon
									icon="check-only"
									className="text-royal-blue"
								/>
							)}
						</div>
					</div>
				</div>
			</components.Option>
		);
	};

	useEffect(() => {
		getSupplierList();
		
	}, []);

	useEffect(() => {
		setListSupplierId(parseInt(activeSupplierList));
	}, [activeSupplierList]);

	const submitHandler = async () => {
		let newMember = [];
		for (let a = 0; a < listCompanies.length; a++) {
			newMember.push(listCompanies[a].value);
		}
		try {
			let payload = {
				supplier_id: newMember,
			};
			let res = await apiV2.post(
				`supplier/${listSupplierId}/attach-supplier`,
				payload
			);
			if (res.status === 200) {
				showToast(res?.data?.message, "Success", true);
				dispatch(
					addSupplierList({
						id: newMember,
					})
				);
				onClose();
				let listId = res?.data?.data?.id;
				let listName = res?.data?.data?.name;
				setTimeout(() => {
					navigate(`/account/${companyId}/supplier-list/${listId}/${listName}`);
				}, 100);
			}
		} catch (err) {
			let msg = err?.response?.data?.message;
			showToast(
				msg !== undefined ? msg : "Failed to add supplier to list",
				"Error"
			);
		}
	};

	const changeOption = (value) => {
		setListSupplierId(value?.value);
	};

	const customStyles = {
		control: (provided) => ({
			...provided,
			with: "100%",
			height: "56px",
			minHeight: "56px",
			borderRadius: "6px",
			boxShadow: "0",
		}),
		option: (provided, state) => ({
			...provided,
			// Apply custom styles for hover
			backgroundColor: state.isSelected
				? "#F9FAFB" // Change background for selected option
				: state.isFocused
					? "#F9FAFB" // Change background for hovered option
					: "#fff", // Default background color
			cursor: "pointer", // Change cursor to pointer on hover
			color: "#101828", // Text color
		}),
	};

	return (
		<div>
			<Drawer
				placement={"right"}
				isOpen={isOpen}
				onClose={onClose}
				size="xl"
				{...props}
			>
				<DrawerOverlay onClick={onClose} />
				<DrawerContent>
					<DrawerHeader
						className="p-0 px-0 text-black"
						borderBottomWidth="1px"
					>
						<div>
							<TabHeader
								noDivider={true}
								heading={"Add to Existing Supplier List"}
								description=""
							>
								<CloseButton onClose={onClose} />
							</TabHeader>
						</div>
					</DrawerHeader>
					<DrawerBody className="max-h-[calc(100vh - 100px)] p-6">
						<div className="container-content relative h-full min-h-[60vh]">
							<LabelForm label="Supplier List" />
							<Select
								label="Supplier List"
								className="ring-ring-blue-primary focus-within:rounded-md focus-within:!border-green-700 focus-within:ring-4"
								options={availableList}
								components={{ Option: CustomOption }}
								styles={customStyles}
								onChange={(value) => changeOption(value)}
								value={{
									label: availableList?.find(
										(item) => item.value === listSupplierId
									)?.label,
									value: listSupplierId,
								}}
							/>
							<Button
								style={{ height: "50px", width: "100%" }}
								type="submit"
								className="mb-5 mt-5 disabled:!opacity-50"
								disabled={listSupplierId === ""}
								onClick={submitHandler}
								data-testid="add-to-supplier-list"
							>
								Add to Supplier List
							</Button>
						</div>
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</div>
	);
};

export default AddSupplierDrawer;
